
@if (data.title) {
  <h1 mat-dialog-title>{{data.title}}</h1>
}

<div mat-dialog-content style="color: #212529;">
  <div [innerHTML]="this.message" ></div>
</div>

<div mat-dialog-actions style="display: flex;  justify-content: flex-end;  gap: 8px; ">
  @if (buttonCancelLabel) {
    <button mat-raised-button id="dialogConfirmCancelButton"
      color="secondary"
      (click)="onClickCancel()">
      {{this.buttonCancelLabel}}
    </button>
  }
  <button mat-raised-button id="dialogConfirmSuccessButton"
    color="primary"
    (click)="onClickClose()">
    {{this.buttonlabel}}
  </button>
</div>
